import React , { forwardRef }from 'react';
import { Input, Label, ErrorText } from '../libCategoria';
// Componente pendiente de migración a react-hook-form

const FormInputFile = React.forwardRef((props, ref) => {

    const [field, fieldOptions, rest] = splitFormProps(props);

    // Use the useField hook with a field and field options
    // to access field state
    const { meta: { error, isTouched }, getInputProps } = useField(field, fieldOptions);

    const { label, style } = rest;
    return (
        <div style={{ ...style, marginBottom: '10px', width: '100%' }}>
            <Label htmlFor={field}>{label}</Label>
            {/* <Input
                ref={validation}
                {...props}
                id={name}
                name={name}
                type={type}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
                className={className}
                style={error && { border: 'solid 1px red' }}
            /> */}
            <Input {...getInputProps({ref,...rest })} />
            {isTouched && error && <ErrorText>{error}</ErrorText>}
        </div>
    )
})

// FormInput.defaultProps = {
//         type: "text",
//         className: ""
//     }

// FormInput.propTypes = {
//         name: PropTypes.string.isRequired,
//         placeholder: PropTypes.string,
//         type: PropTypes.oneOf(['text', 'number', 'email', 'password']),
//         className: PropTypes.string,
//         value: PropTypes.any,
//         onChange: PropTypes.func.isRequired
//     }

export default React.memo(FormInputFile);